import { AnyAction } from "redux";

import { CaseAdmin, PatientFullInsurance, PatientGuarantor } from "pwapi";

import {
  ADMIN_UPDATE_PATIENT_GUARANTOR_SUCCESS,
  ADMIN_CREATE_PATIENT_GUARANTOR_SUCCESS,
  ADMIN_UPDATE_INTEGRATIONS_SUCCESS,
} from "shared/actions/adminConstants";

import {
  CREATE_LIS_INSURANCE_SUCCESS,
  DELETE_LIS_INSURANCE_SUCCESS,
  FETCH_LIS_CASE_REQUEST,
  FETCH_LIS_CASE_SUCCESS,
  UPDATE_LIS_INSURANCE_SUCCESS,
  UPDATE_LIS_LOCATION_SUCCESS,
  UPDATE_LIS_PATIENT_SUCCESS,
} from "../constants";

export interface PatientState
  extends Omit<CaseAdmin["patient"], "first_name" | "insurance" | "guarantor"> {
  first_name?: "";
  insurance?: PatientFullInsurance[];
  guarantor?: PatientGuarantor[];
}

export const AdminPatientReducer = (
  state: PatientState = {},
  action: AnyAction
): PatientState => {
  switch (action.type) {
    case FETCH_LIS_CASE_REQUEST:
      return {};
    case FETCH_LIS_CASE_SUCCESS:
      return action.payload.response.patient || {};
    case UPDATE_LIS_PATIENT_SUCCESS:
      return {
        ...action.payload.response,
        address: state.address,
      };
    case CREATE_LIS_INSURANCE_SUCCESS:
      return {
        ...state,
        insurance: state.insurance
          ? [...state.insurance, action.payload.response]
          : [action.payload.response],
      };
    case UPDATE_LIS_INSURANCE_SUCCESS:
      const index = state.insurance
        ? state.insurance.findIndex(
            (insurance) => insurance.id === action.payload.response.id
          )
        : -1;
      return {
        ...state,
        insurance:
          state.insurance?.length && index > -1
            ? [
                ...state.insurance.slice(0, index),
                action.payload.response,
                ...state.insurance.slice(index + 1),
              ]
            : state.insurance,
      };
    case DELETE_LIS_INSURANCE_SUCCESS:
      return {
        ...state,
        insurance: state.insurance
          ? state.insurance.filter((insur) => insur.id !== action.args.id)
          : [{} as PatientFullInsurance],
      };
    case UPDATE_LIS_LOCATION_SUCCESS:
      return {
        ...state,
        address: { ...action.payload.response },
      };
    case ADMIN_UPDATE_INTEGRATIONS_SUCCESS:
      return (
        state && {
          ...state,
          clinic: action.payload.clinic,
          external_patient_id: action.payload.patient?.external_patient_id,
        }
      );
    case ADMIN_CREATE_PATIENT_GUARANTOR_SUCCESS:
    case ADMIN_UPDATE_PATIENT_GUARANTOR_SUCCESS:
      return (
        state && {
          ...state,
          guarantor: [action.payload],
        }
      );
    default:
      return state;
  }
};
